import { render, staticRenderFns } from "./Legal_page.vue?vue&type=template&id=53979a2e&"
import script from "./Legal_page.vue?vue&type=script&lang=js&"
export * from "./Legal_page.vue?vue&type=script&lang=js&"
import style0 from "./Legal_page.vue?vue&type=style&index=0&id=53979a2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports